import useAdjustFontSizes from '@/hooks/useAdjustFontSizes';
import Image from "next/image";
import { useRef, useState } from "react";

const ReviewCard = ({ slide }) => {
    const reviewRef = useRef(null);

    const elements = {
        review: { ref: reviewRef, maxFontSize: 16, maxHeight: 96 },
    };

    const [fontSizes, setFontSizes] = useState({
        review: 16,
    });

    // Dynamic font sizing for review text
    useAdjustFontSizes(elements, [slide.review], setFontSizes);

    return (
        <div className="flex gap-6 items-center">
            <div className="relative rounded-[3px] border-[0.5px] border-[#949494] shadow-reviewImageShadow w-[171px] h-[227px]">
                <Image
                    src={slide.image}
                    alt=""
                    fill
                    className="object-cover pointer-events-none"
                    draggable={false}
                />
            </div>
            <div className="flex rounded-[3px] fex-col px-[10px] pt-[12px] pb-3 flex-col w-[171px] h-[227px] shadow-reviewShadow border-[0.5px] border-[#949494] justify-between">
                <div
                    ref={reviewRef}
                    className="text-[#2B2B2B] italic"
                    style={{
                        fontSize: `${fontSizes.review}px`,
                        lineHeight: `${fontSizes.review + 5}px`,
                    }}
                >
                    {slide.review}
                </div>
                <div className="flex flex-col items-center">
                    <Image
                        src={slide.avatar}
                        alt=""
                        width={38}
                        height={38}
                        className="rounded-full mt-3 pointer-events-none"
                        draggable={false}
                    />
                    <div className="text-[#000000] text-[14px] font-[300] mt-2">{slide.name}</div>
                    <div className="flex mt-1">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <svg key={i} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6373 5.28603C14.5952 5.14386 14.512 5.01732 14.3982 4.92239C14.2843 4.82745 14.1449 4.76837 13.9975 4.75261L9.95551 4.37599L8.35805 0.471258C8.30507 0.332629 8.21125 0.213351 8.089 0.129203C7.96675 0.0450541 7.82184 0 7.67343 0C7.52502 0 7.38011 0.0450541 7.25786 0.129203C7.13561 0.213351 7.04179 0.332629 6.98881 0.471258L5.39135 4.37599L1.34871 4.75611C1.20182 4.77188 1.06282 4.83054 0.949047 4.92477C0.83527 5.01901 0.751746 5.14464 0.708889 5.28603C0.66349 5.43005 0.659776 5.58399 0.698177 5.73004C0.736578 5.87608 0.815527 6.00828 0.925897 6.11135L3.9808 8.90655L3.08057 13.05C3.04759 13.1973 3.05727 13.3509 3.10847 13.4928C3.15968 13.6348 3.25029 13.7592 3.36968 13.8515C3.48586 13.9404 3.62644 13.9917 3.77258 13.9984C3.91871 14.0052 4.06342 13.9671 4.18731 13.8893L7.67343 11.7157L11.1582 13.89C11.2821 13.9679 11.427 14.006 11.5732 13.9992C11.7195 13.9925 11.8602 13.9412 11.9765 13.8522C12.0959 13.76 12.1866 13.6356 12.2378 13.4936C12.289 13.3516 12.2987 13.198 12.2656 13.0507L11.3647 8.91075L14.4196 6.11555C14.5308 6.01217 14.6103 5.87925 14.6487 5.73234C14.6871 5.58544 14.6836 5.43063 14.6373 5.28603Z" fill="#FDBA12" />
                            </svg>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewCard;